// extracted by mini-css-extract-plugin
export default {"container":"ZX-z","title":"_X-z","link":"aY-z"};